export default {
  cleaning: "Erbrachte\nDienstleistungen",
  provider: "Dienstleister",
  announcements: "Ankündigungen",
  help: "Hilfe",
  profile: "Profil",
  logout: "Abmelden",
  cleaning_page_title: "Übersichtstabelle aller Dienstleistungen",
  provider_page_title:
    "Verwalten Sie Ihre Dienstleistungen und legen Sie neue Dienstleister an",
  announcement_page_title:
    "Verwalten Sie Ihre Ankündigungen oder erstellen eine neue",
  location_page_title:
    "Verwalten Sie Ihre Standortgruppen oder erstellen eine neue",
  profile_page_title: "Verwalten Sie Ihr Profil",
  cleaning_subtitle:
    "Hier sehen Sie alle Dienstleistungen, die an der Digitalen Haustafel erfasst wurden. Diese können Sie sich beliebig nach Datum aufsteigend/absteigend, nach Standort, Dienstleister und Tätigkeit filtern. Es besteht außerdem die Möglichkeit, die Liste zur weiteren Verarbeitung als CSV-Datei zu exportieren.",
  provider_subtitle:
    "In diesem Bereich können Sie Ihre beauftragten Dienstleister neu anlegen, verwalten und diesem Tätigkeiten zuweisen.",
  announcement_subtitle:
    "Hier können Sie Ankündigungen erstellen, anpassen und auf einzelne oder alle Standorte verteilen. Das Anlegen oder Abrufen von Vorlagen ist ebenso möglich.",
  location_subtitle:
    "Hier verwalten Sie Ihre Standorte und können diese entsprechend gruppieren - zum Beispiel nach Quartier, Verwaltungseinheit, Postleitzahl etc.",
  profile_subtitle:
    "In diesem Bereich können Sie das optische Erscheinungsbild der Dienstleistungserfassung auf Ihren Haustafeln anpassen. Die Anpassungen gelten für all Ihre Haustafeln.",
  filter_by: "Filtern nach",
  newest_first: "Neueste zuerst",
  oldest_first: "Älteste zuerst",
  single_days: "Einzelne Tage",
  show_transferdate: "zeige Übermittlungsdatum",
  pick_one_or_more_days: "Wählen Sie einen oder mehrere Tage",
  to: "Bis",
  start: "Start",
  end: "Ende",
  date: "Datum",
  location: "Standort",
  asc: "Alphabetisch aufsteigend",
  desc: "Alphabetisch absteigend",
  search_criteria: "Suchkriterium",
  service: "Tätigkeit",
  status: "Status",
  loading: "Laden...",
  locations: "Standorte",
  all_services_loaded: "Alle Tätigkeiten wurden geladen.",
  last_week: "Letze Woche",
  last_month: "Letzter Monat",
  last_3_months: "Letzte 3 Monate",
  created_providers: "Angelegte Dienstleister",
  delete_provider_confirm:
    "Sind Sie sicher, dass Sie diesen Dienstleister löschen möchten?",
  assigned_services: "Zugewiesene Tätigkeiten",
  no_services_assigned: "Keine Tätigkeiten zugewiesen.",
  add_new_provider: "Neuen Dienstleister anlegen",
  add_provider: "Dienstleister hinzufügen",
  edit_provider: "Dienstleister bearbeiten",
  enter_data: "Daten eingeben",
  email_address: "E-Mail Adresse",
  pin_for_login: "PIN-Nummer für Anmeldung auf DHT",
  password_for_login: "Passwort für die Online-Anmeldung",
  password_for_login_missing: "Passwort für die Online-Anmeldung fehlt",
  add_service: "Tätigkeit(en) hinzufügen",
  cancel: "Abbrechen",
  save: "Speichern",
  service_deleted: "Tätigkeit wurde gelöscht",
  service_created: "Tätigkeit wurde erstellt",
  service_updated: "Tätigkeit wurde aktualisiert",
  provider_deleted: "Dienstleister wurde gelöscht",
  provider_updated: "Dienstleister wurde aktualisiert",
  provider_created: "Dienstleister wurde erstellt",
  provider_not_exist: "Dienstleister existiert nicht",
  enter_password: "Bitte geben Sie ein Passwort ein.",
  enter_name: "Bitte geben Sie einen Namen ein.",
  enter_username: "Bitte geben Sie einen Benutzernamen ein.",
  enter_group_name: "Bitte geben Sie einen Standortgruppennamen ein.",
  enter_description: "Bitte geben Sie eine Beschreibung ein.",
  enter_email: "Bitte geben Sie eine eMail-Adresse ein.",
  enter_valid_email: "Bitte geben Sie eine gültige eMail-Adresse ein.",
  enter_pin: "Bitte geben Sie eine PIN ein.",
  enter_pin_exists: "PIN ist bereits vorhanden",
  enter_email_exists: "Email ist bereits vorhanden",
  enter_name_exists: "Name ist bereits vorhanden",
  announcement_overview: "Übersicht Ankündigungen",
  current: "Aktuell",
  expired: "Abgelaufen",
  at: "vom",
  till: "bis",
  deleted_announcement_confirm:
    "Sind Sie sicher, dass Sie diese Ankündigung löschen wollen?",
  phone: "Telefonnummer",
  restrictions: "Einschränkungen",
  duty: "Mitwirkungspflicht",
  description_service: "Beschreibung der Tätigkeit",
  select_template: "Als Vorlage auswählen",
  create_announcement: "Neue Ankündigung erstellen",
  announcement_information: "Informationen zur Ankündigung",
  edit_announcement: "Ankündigung bearbeiten",
  chose_provider: "Dienstleister auswählen",
  chose_service: "Tätigkeit auswählen",
  company: "Firma",
  title: "Titel",
  period: "Zeitraum",
  start_time: "Beginn",
  end_time: "Ende",
  show_weekend: "am Wochenende zeigen",
  chose: "Auswählen",
  contact_on_site: "Ansprechpartner vor Ort",
  contact_phone: "Telefonnummer Ansprechpartner",
  location_for_announcement: "Standort für Ankündigung",
  single_locations: "Einzelne Standorte",
  chose_group: "Standortgruppe auswählen",
  locations_for_group: "Standorte für die Gruppe",
  locations_for_available: "verfügbar an allen Standorten",
  create: "Erstellen",
  select_date: "Bitte wählen Sie ein Datum.",
  no_title: "Bitte vergeben Sie einen Titel.",
  no_description: "Bitte tragen Sie eine Beschreibung ein.",
  no_company: "Bitte tragen Sie die Firma ein.",
  no_contact: "Bitte geben Sie eine Kontaktperson ein.",
  no_start_time: "Bitte geben Sie eine Uhrzeit für den Beginn ein.",
  no_end_time: "Bitte geben Sie eine Uhrzeit für den Abschluss ein.",
  no_group: "Bitte wählen Sie mindestens eine Standortgruppe aus.",
  no_location: "Bitte wählen Sie mindestens einen Standort aus.",
  no: "Nein",
  yes: "Ja",
  only_saturday: "nur am Samstag",
  only_sunday: "nur am Sonntag",
  announcement_created: "Ankündigung erfolgreich erstellt.",
  announcement_changed: "Ankündigung erfolgreich geändert.",
  announcement_deleted: "Ankündigung erfolgreich gelöscht.",
  bg_color: "Kalender-Hintergrund",
  bg_color_service: "Hintergrund für Tätigkeit",
  bg_color_today: "Hintergrund für „Heute“",
  bg_color_announcements: "Hintergrund für Ankündigungen",
  text_color: "Kalender-Beschriftung",
  text_color_service: "Vordergrund für Tätigkeit",
  text_color_today: "Vordergrund für „Heute“",
  text_color_announcements: "Vordergrund für Ankündigungen",
  capture: "Erfassung",
  preview: "Vorschau",
  details: "Detailansicht",
  service_title: "Titel der Dienstleistung",
  service_subtitle: "Beschreibungstext der Dienstleistung.",
  visible_for_tenants: "Für Mieter sichtbar",
  invisible_for_tenants: "Für Mieter unsichtbar",
  multiple_locations: "Tätigkeit die ortsübergreifend stattfindet",
  group_for_service: "Standortgruppe für Tätigkeit",
  add_group: "Standortgruppe erstellen",
  group_name: "Standortgruppenname",
  delete_service: "Tätigkeit löschen",
  create_service: "Tätigkeit hinzufügen",
  edit_service: "Tätigkeit speichern",
  select_group_or_create:
    "Bitte wählen Sie eine Standortgruppe oder erstellen Sie eine Standortgruppe und wählen diese dann aus.",
  location_group_created: "Standortgruppe wurde erfolgreich erstellt.",
  login_data: "Benutzerdaten",
  calender_view_dht: "Kalenderansicht Digitale Haustafel",
  upload_logo: "Logo hochladen",
  upload_field_text:
    "Ziehen Sie die Datei hierher oder <em>klicken Sie hier, um die Datei auszuwählen</em>",
  logo_advise: "Logo für Clientansicht (64px Höhe empfohlen)",
  frontend_view_calendar: "Voransicht Kalender",
  today: "Heute",
  logo_updated: "Logo wurde aktualisiert.",
  colors_updated: "Farben wurden aktualisiert.",
  password_updated: "Passwort wurde aktualisiert.",
  old_password_missmatch: "Altes Passwort war nicht korrekt.",
  colors_update_error: "Konnte die Farben nicht aktualisieren.",
  added_location_groups: "Standortgruppen",
  delete_group_confirm:
    "Sind Sie sicher, dass Sie diese Standortgruppe löschen möchten?",
  assigned_locations: "Folgende Standorte wurden zugeordnet",
  no_assigned_locations: "Es wurden keine Standorte zugeordnet",
  add_locations_group: "Standortgruppen hinzufügen",
  edit_locations_group: "Standortgruppen bearbeiten",
  locations_group_deleted: "Standortgruppe erfolgreich gelöscht.",
  locations_group_changed: "Standortgruppe erfolgreich geändert.",
  locations_group_added: "Standortgruppe erfolgreich hinzugefügt.",
  login_title: "Anmeldung <br>Kundenportal",
  login_failed: "Die Zugangsdaten sind nicht korrekt.",
  username: "Benutzername",
  password: "Passwort",
  login: "Anmelden",
  select_client: "Ihren Auftraggeber <br />auswählen",
  select_client_text: "Bitte wählen Sie einen Auftraggeber",
  please_choose: "Bitte auswählen",
  continue: "Weiter",
  client_not_found: "Auftraggeber nicht gefunden",
  user_subtitle:
    "Hier können Sie neue Benutzer/Kunden anlegen und diese verwalten.",
  user_page_title: "Benutzerübersicht",
  created_users: "Benutzerübersicht",
  add_new_user: "Neuen Benutzer hinzufügen",
  loginname: "Login-Name",
  add_user: "Benutzer hinzufügen",
  timetrackingmodule: "Modul zur Zeiterfassung",
  providermodule: "Modul für Dienstleister",
  delete_user_confirm:
    "Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?",
  user_created: "Benutzer wurde erfolgreich angelegt.",
  user_changed: "Benutzer wurde erfolgreich geändert.",
  user_deleted: "Benutzer wurde erfolgreich gelöscht.",
  edit_user: "Benutzer bearbeiten",
  site_remote: "SiteRemote Team ID",
  client_urls: "Client URLs",
  client_urls_protection: "URL-Schutz",
  client_urls_protection_changed: "URL-Schutz angepasst",
  client_urls_protection_enabled: "Schutz aktivieren",
  enter_site_remote: "Bitte geben Sie die SiteRemote Team ID ein.",
  enter_loginname: "Bitte geben Sie einen Login-Namen ein.",
  loginname_already_exists: "Login-Name existiert bereits.",
  export_to_csv: "als CSV exportieren",
  not_available: "nicht verfügbar",
  delete_logo: "Logo löschen",
  delete_logo_confirm: "Sind Sie sicher, dass Sie das Logo löschen möchten?",
  logo_deleted: "Das Logo wurde erfolgreich gelöscht.",
  shortname: "Name (kurz)",
  duplicate_group_name: "Der Standortgruppenname ist bereits vorhanden",
  old_password: "Altes Passwort",
  new_password: "Neues Passwort",
  Logout: "Abmelden",
  provider_onlineaccess: "Separater Zugang für Dienstleister",
  notices_nav: "Erfasste&nbsp;Notizen\nder&nbsp;Dienstleister",
  notices_tableheader: "Erfasste Notiz des Dienstleisters",
  notices_page_title: "Übersichtstabelle aller Notizen",
  notices_subtitle:
    "Hier sehen Sie alle Notizen, die an der Digitalen Haustafel erfasst wurden. Diese können Sie sich beliebig nach Datum aufsteigend/absteigend, nach Standort und  Dienstleister filtern. Es besteht außerdem die Möglichkeit, die Liste zur weiteren Verarbeitung als CSV-Datei zu exportieren.",
  notices_field_avaible: "Notizen ermöglichen",
  status_begin: "begonnen",
  status_end: "beendet",
  time_schedule: "Zeitplan",
  time_schedule_cycle: "wiederkehrend",
  time_schedule_none: "keiner",
  time_schedule_aktiv: "aktiv",
  time_schedule_weekly: "wöchentlich",
  time_schedule_monthly: "monatlich",
  time_schedule_selectdays: "Tageswahl",
  time_schedule_weekcycle: "Wochenrhythmus",
  time_schedule_monthcycle: "Monatsrhythmus",

  time_schedule_every_week_1stday:
    "jeden ersten ausgewählten Wochentag im Monat",
  time_schedule_every_week_2stday:
    "jeden zweiten ausgewählten Wochentag im Monat",
  time_schedule_every_week_3stday:
    "jeden dritten ausgewählten Wochentag im Monat",
  time_schedule_every_week_4stday:
    "jeden vierten ausgewählten Wochentag im Monat",

  time_schedule_every_week_none: "kein Wochenrhythmus",
  time_schedule_every_week: "jede Woche",
  time_schedule_every_weekodd: "jede gerade Woche",
  time_schedule_every_weekeven: "jede ungerade Woche",
  time_schedule_every_week2: "aller 2 Wochen",
  time_schedule_every_week3: "aller 3 Wochen",
  time_schedule_every_week4: "aller 4 Wochen",

  time_schedule_every_month: "jeden Monat",
  time_schedule_every_month2: "jeden zweiten Monat",
  time_schedule_every_month3: "jeden dritten Monat",
  time_schedule_every_month4: "jeden vierten Monat",
  time_schedule_every_month6: "halbjährlich",

  time_schedule_error_day: "Bitte wählen Sie ein Wochentag aus",
  time_schedule_error_dayinmonth: "Bitte wählen Sie ein Monatstag aus",
  time_schedule_error_plan: "Bitte wählen den Zyklus aus",
  time_schedule_error_weekly: "Bitte wählen den Wochenzyklus aus",
  time_schedule_error_monthly: "Bitte wählen den Monatszyklus aus",
  time_schedule_lastdayofmonth: "letzter Tag des Monats",
  time_schedule_firstdayofmonth: "erster Tag des Monats",

  monday: "Montag",
  tuesday: "Dienstag",
  wednesday: "Mittwoch",
  thursday: "Donnerstag",
  friday: "Freitag",
  saturday: "Samstag",
  sunday: "Sonntag",
  editor_site_remote_idteam: "Team Id in editor(alt)",
  skonline_site_remote_idteam: "Team Id in skonline/cms(neu)",
  users: "Benutzer",
  report: "Automatische Reporte",
  save_report: "Reporteinstellungen wurden gespeichert.",
  save_settings: "Einstellungen wurden gespeichert.",
  save_settings_error: "Einstellungen konnten nicht gespeichert werden.",
  profile_settings: "weitere Einstellungen",
  send_email_onadd: "E-Mail Benachrichtung bei Eintragungen",
  salt: "neues Geheimnis",
  oldsalt: "altes Geheimnis",
  olddate: "altes Geheimnis gültig bis",
  getconfiguration_project: "Herunterladen der Konfigurationdatei für CMS",
  getconfiguration_project_copy: "in die Zwischenablage kopieren",
  structurenumber: "Strukturnummer",
  can_deleteentries: "Kann alle Einträge löschen",
  btn_deleteentries: "alle Einträge löschen",
  deleteentries_success: "Einträge wurden gelöscht.",
  deleteentries_fail: "Einträge wurden nicht gelöscht.",
  deleteentry_success: "Eintrag wurde gelöscht.",
  deleteentry_fail: "Eintrag wurde nicht gelöscht.",
  deleteentries_prompt: "Sollen alle Einträge gelöscht werden?",
  deleteentry_prompt: "Soll der Eintrag gelöscht werden?",
  deleteentry_msg: "",
  send_email_notice: "E-Mail Benachrichtung bei Eintragungen von Notizen",
  setnotice_success: "Notizstatus wurde geändert.",
  setnotice_fail: "Notizstatus kann nicht geändert werden.",
  setnotice_prompt: "Soll diese Notiz als erledigt markiert werden?",
  setnotice_done: "erledigt",
  setnotice_open: "offen",
  setnotice_msg: "",
  notice_actions: "Erledigt",
  notice_sort: "nur offene Notizen",
  actions: "Aktionen",
  showannoucement_inrange_day:
    "Wieviele Tage vorher wird die Ankündigung sichtbar:",
  showannoucement_inrange_day_error: "Bitte geben Sie ein ganzzahlige Zahl ein",
  showannoucement_inrange_day_notactive: "wird immer angezeigt"
};
